import type { BackstageTypography } from '@backstage/theme';

/**
 * Klean is Kärcher's proprietary corporate typeface. The licensed `.woff2`
 * files are not in the repo yet, so the stack degrades to Inter/system until
 * they land — dropping them into `src/assets/fonts` is then the only change
 * needed.
 */
export const karcherFontFamily =
  "'Klean', 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif";

/**
 * Kärcher's headline voice is the narrow black cut at weight 900. The uppercase
 * half of that signature is deliberately *not* applied here: `Header` renders
 * its title as `h1`, and on entity pages that title is the entity name.
 * Uppercasing case-sensitive identifiers like `kdp-backstage` would be
 * actively misleading, so the transform is applied per component instead.
 *
 * `createBaseThemeOptions` replaces typography wholesale rather than merging
 * it, so every heading has to be listed or it silently falls back to plain
 * Material UI sizes.
 */
export const karcherTypography: BackstageTypography = {
  htmlFontSize: 16,
  fontFamily: karcherFontFamily,
  h1: { fontSize: 44, fontWeight: 900, marginBottom: 10 },
  h2: { fontSize: 36, fontWeight: 900, marginBottom: 8 },
  // Drives `Header.title`, which is the page title on every route.
  h3: { fontSize: 28, fontWeight: 900, marginBottom: 6 },
  h4: { fontSize: 24, fontWeight: 700, marginBottom: 6 },
  h5: { fontSize: 20, fontWeight: 700, marginBottom: 4 },
  h6: { fontSize: 18, fontWeight: 700, marginBottom: 2 },
};
